import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../../app/store";

interface SeedRendersModalState {
  isOpened: boolean;
}

const initialState: SeedRendersModalState = {
  isOpened: false,
};

const seedRendersModalSlice = createSlice({
  name: "seedRendersModal",
  initialState,
  reducers: {
    open: (state) => { state.isOpened = true; },
    close: () => initialState,
  },
});

export default seedRendersModalSlice.reducer;
export const { open, close } = seedRendersModalSlice.actions;
export const seedRendersModalState = (state: RootState): SeedRendersModalState =>
  state.seedRendersModal;
